var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 50,
    transform: "matrix(-1 0 0 1 50 50)",
    fill: "#4643C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2168 46.7831C51.5103 45.0774 49.1963 44.1191 46.7835 44.1191C44.3707 44.1191 42.0566 45.0774 40.3501 46.7831L33.9147 53.2165C32.2082 54.923 31.2495 57.2375 31.2495 59.6508C31.2495 62.0642 32.2082 64.3787 33.9147 66.0852C35.6212 67.7917 37.9357 68.7504 40.3491 68.7504C42.7624 68.7504 45.077 67.7917 46.7835 66.0852L50.0001 62.8685",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7837 53.2163C48.4902 54.9221 50.8042 55.8803 53.217 55.8803C55.6298 55.8803 57.9439 54.9221 59.6504 53.2163L66.0858 46.783C67.7923 45.0765 68.751 42.762 68.751 40.3486C68.751 37.9352 67.7923 35.6207 66.0858 33.9142C64.3793 32.2077 62.0648 31.249 59.6514 31.249C57.238 31.249 54.9235 32.2077 53.217 33.9142L50.0004 37.1309",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.79def66e51045473bd7c0013dc08cb71.svg";
export { ForwardRef as ReactComponent };